import React from 'react';
import { Link } from 'react-router-dom';
import { XIcon, PlusIcon, MinusIcon, ShoppingCartIcon } from 'lucide-react';
export const CartPage = () => {
  // Mock cart items - in a real app, this would be managed with state
  const cartItems = [{
    id: 1,
    name: 'MacBook Pro 2021',
    condition: 'Refurbished - Excellent',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pVpXANE4MPeUTAwYJSN7su/Screenshot_2025-08-06_at_07.25.36.png',
    price: 1299,
    quantity: 1
  }, {
    id: 3,
    name: 'Gold Bar 1oz',
    condition: 'Investment Grade - 99.99% Pure',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oaU7AVpzGveQuccM4pJ9vy/Screenshot_2025-08-06_at_07.29.11.png',
    price: 2084,
    quantity: 1
  }];
  const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
  const shipping = 0; // Free shipping
  const tax = subtotal * 0.08; // 8% tax
  const total = subtotal + shipping + tax;
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-183">
      <div className="container mx-auto px-4 py-8" data-id="element-184">
        <h1 className="text-3xl font-bold mb-8" data-id="element-185">Your Cart</h1>
        {cartItems.length > 0 ? <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-186">
            {/* Cart Items */}
            <div className="lg:col-span-2" data-id="element-187">
              <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6" data-id="element-188">
                {/* Cart Header */}
                <div className="border-b border-gray-200 p-4" data-id="element-189">
                  <div className="grid grid-cols-12 gap-4" data-id="element-190">
                    <div className="col-span-6" data-id="element-191">
                      <span className="font-medium" data-id="element-192">Product</span>
                    </div>
                    <div className="col-span-2 text-center" data-id="element-193">
                      <span className="font-medium" data-id="element-194">Price</span>
                    </div>
                    <div className="col-span-2 text-center" data-id="element-195">
                      <span className="font-medium" data-id="element-196">Quantity</span>
                    </div>
                    <div className="col-span-2 text-right" data-id="element-197">
                      <span className="font-medium" data-id="element-198">Total</span>
                    </div>
                  </div>
                </div>
                {/* Cart Items */}
                {cartItems.map(item => <div key={item.id} className="border-b border-gray-200 p-4" data-id="element-199">
                    <div className="grid grid-cols-12 gap-4 items-center" data-id="element-200">
                      <div className="col-span-6" data-id="element-201">
                        <div className="flex items-center" data-id="element-202">
                          <button className="text-gray-400 hover:text-gray-600 mr-4" data-id="element-203">
                            <XIcon size={16} data-id="element-204" />
                          </button>
                          <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-md border border-gray-200 mr-4" data-id="element-205">
                            <img src={item.image} alt={item.name} className="h-full w-full object-contain object-center" data-id="element-206" />
                          </div>
                          <div data-id="element-207">
                            <h3 className="font-medium text-gray-800" data-id="element-208">
                              {item.name}
                            </h3>
                            <p className="text-sm text-gray-500" data-id="element-209">
                              {item.condition}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-span-2 text-center" data-id="element-210">
                        <span className="font-medium" data-id="element-211">${item.price}</span>
                      </div>
                      <div className="col-span-2" data-id="element-212">
                        <div className="flex items-center justify-center" data-id="element-213">
                          <button className="bg-gray-100 text-gray-600 p-1 rounded-l-md hover:bg-gray-200 transition-colors" data-id="element-214">
                            <MinusIcon size={16} data-id="element-215" />
                          </button>
                          <input type="text" value={item.quantity} className="w-10 text-center border-t border-b border-gray-200 py-1" readOnly data-id="element-216" />
                          <button className="bg-gray-100 text-gray-600 p-1 rounded-r-md hover:bg-gray-200 transition-colors" data-id="element-217">
                            <PlusIcon size={16} data-id="element-218" />
                          </button>
                        </div>
                      </div>
                      <div className="col-span-2 text-right" data-id="element-219">
                        <span className="font-medium" data-id="element-220">
                          ${(item.price * item.quantity).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>)}
              </div>
              {/* Continue Shopping */}
              <Link to="/shop" className="inline-flex items-center text-green-500 hover:text-green-600 transition-colors" data-id="element-221">
                <ShoppingCartIcon size={16} className="mr-2" data-id="element-222" />
                <span data-id="element-223">Continue Shopping</span>
              </Link>
            </div>
            {/* Order Summary */}
            <div data-id="element-224">
              <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-225">
                <div className="p-6" data-id="element-226">
                  <h2 className="text-lg font-bold mb-4" data-id="element-227">Order Summary</h2>
                  <div className="space-y-3 mb-6" data-id="element-228">
                    <div className="flex justify-between" data-id="element-229">
                      <span className="text-gray-600" data-id="element-230">Subtotal</span>
                      <span className="font-medium" data-id="element-231">
                        ${subtotal.toFixed(2)}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-232">
                      <span className="text-gray-600" data-id="element-233">Shipping</span>
                      <span className="font-medium text-green-500" data-id="element-234">Free</span>
                    </div>
                    <div className="flex justify-between" data-id="element-235">
                      <span className="text-gray-600" data-id="element-236">Estimated Tax</span>
                      <span className="font-medium" data-id="element-237">${tax.toFixed(2)}</span>
                    </div>
                    <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-238">
                      <span className="font-bold" data-id="element-239">Total</span>
                      <span className="font-bold" data-id="element-240">${total.toFixed(2)}</span>
                    </div>
                  </div>
                  <Link to="/checkout" className="block w-full bg-green-500 text-white text-center py-3 rounded-lg hover:bg-green-600 transition-colors" data-id="element-241">
                    Proceed to Checkout
                  </Link>
                </div>
              </div>
            </div>
          </div> : <div className="bg-white rounded-xl shadow-sm p-8 text-center" data-id="element-242">
            <div className="flex justify-center mb-4" data-id="element-243">
              <ShoppingCartIcon size={64} className="text-gray-300" data-id="element-244" />
            </div>
            <h2 className="text-xl font-bold mb-2" data-id="element-245">Your cart is empty</h2>
            <p className="text-gray-600 mb-6" data-id="element-246">
              Looks like you haven't added any products to your cart yet.
            </p>
            <Link to="/shop" className="inline-block bg-green-500 text-white py-3 px-6 rounded-lg hover:bg-green-600 transition-colors" data-id="element-247">
              Start Shopping
            </Link>
          </div>}
      </div>
    </div>;
};